import { render, staticRenderFns } from "./FiguraTransporte.vue?vue&type=template&id=eb6dbd64&"
import script from "./FiguraTransporte.vue?vue&type=script&lang=js&"
export * from "./FiguraTransporte.vue?vue&type=script&lang=js&"
import style0 from "./FiguraTransporte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports